import React, { useState, useEffect, useMemo } from "react";
import BarGraphOverview from "../Graphs/BarGraphOverview";
import { fromDollar, getPercentile } from "../../utils/Constants/systemSetting";
import { Checkbox } from "antd";
import { useSelector } from "react-redux";

export default function FinancialBarGraph({
  year,
  executive,
  measure,
  cohortTableSelector,
  sortedTableKeys,
  tablePagination,
  customXaxisTitle = null,
  isPeerGroupGraph = false,
}) {
  const { companies } = useSelector((state) => state.CompaniesReducer);
  const [cohortExecutives, setCohortExecutives] = useState([]);

  useEffect(() => {
    const { current, pageSize } = tablePagination;
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    // console.log(sortedTableKeys);

    setCohortExecutives(
      sortedTableKeys
        .slice(sortedTableKeys?.length > 40 ? startIndex : 0)
        .filter((key) => {
          return (
            key &&
            key !== null &&
            key.measureValue &&
            key?.measureValue !== null &&
            !["N/A", "N", "P"].some((excludeTerm) =>
              key.measureValue.toString().includes(excludeTerm),
            )
          );
        })
        .map((key) => {
          return {
            name: key.name,
            company: companies[key.name]?.Company || "",
            value:
              key.toString().includes("%") || measure?.dataType === "%"
                ? parseFloat(key.measureValue)
                : fromDollar(key.measureValue),
            isExecPage: key.name === executive.name,
            // key.name.props.children &&
            // key.ticker &&
            // executive.name &&
            // executive.Ticker &&
            // key.name.props.children.replace("*", "") ===
            //   executive.name.replace("*", "") &&
            // key.ticker === executive.Ticker,
            percentile: key?.measurePercentile,
          };
        }),
    );
  }, [sortedTableKeys, tablePagination, companies, measure, executive]);

  const percentileLines = useMemo(() => {
    const percentileLineValues = [25, 50, 75, 90];
    return percentileLineValues.map((value) => ({
      percentile: value,
      amount: getPercentile(
        sortedTableKeys
          .filter((key) => {
            return (
              key &&
              key !== null &&
              key?.measureValue &&
              key?.measureValue !== null &&
              !["N/A", "N", "P"].some((excludeTerm) =>
                key.measureValue.toString().includes(excludeTerm),
              )
            );
          })
          .map((key) => fromDollar(key.measureValue))
          .sort((a, b) => a - b),
        value / 100,
      ),
    }));
  }, [sortedTableKeys]);

  const [showPercenileLines, setShowPercentileLines] = useState(true);

  // console.log(cohortExecutives);

  return (
    <div
      className="c-table "
      style={{
        flex: 2,
      }}
    >
      <div className="financial-table">
        {measure.title && (
          <>
            <div
              style={{
                width: "100%",
                // paddingRight: "max(65px, 7.5%)",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {isPeerGroupGraph && (
                <Checkbox
                  checked={showPercenileLines}
                  onChange={() => setShowPercentileLines(!showPercenileLines)}
                >
                  Show Percentile Benchmarks
                </Checkbox>
              )}
            </div>
            <div className=" graphs" style={{ margin: 0, maxHeight: 400 }}>
              <BarGraphOverview
                data={cohortExecutives.slice(0, 40)}
                year={year}
                company={
                  `${executive.name}${cohortTableSelector ? `'s ${cohortTableSelector}` : ""}` +
                  (cohortExecutives.length > 40
                    ? " (First 40 Companies in Table)"
                    : "")
                }
                measure={measure}
                percentileLines={percentileLines}
                showPercenileLines={isPeerGroupGraph && showPercenileLines}
                currentExecutivePage={executive}
                customXaxisTitle={customXaxisTitle}
                abbreviateNames={false}
                hideLegend={!isPeerGroupGraph}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
